// extracted by mini-css-extract-plugin
var _1 = "cVFLze8UWrkLM1xsbaI6";
var _2 = "HL6xh6bIfxz8rbC88CYL";
export { _1 as "marks", _2 as "scroll" }
